import request from '@/utils/request';
export async function get_wechat_app_id() {
  return request.post('/wx/get_wechat_app_id');
}